export default {"src":"/_next/static/media/blue-tick.211e1e15.svg","height":16,"width":16};